import { createRoute, redirect } from '@tanstack/react-router'
import { lazy } from 'react'
import type { LazyPage } from './lazy-page'
import { guardAt } from './products'
import { rootRoute } from './root'

const SettingsPage: LazyPage<{ section?: string }> = lazy(() =>
  import('../../routes/SettingsPage').then((m) => ({
    default: m.SettingsPage,
  })),
)
// Settings' left rail is in the path too: /settings shows the first section the
// caller can see, /settings/$section deep-links a specific one.
const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: () => <SettingsPage />,
})
function SettingsSectionView() {
  const { section } = settingsSectionRoute.useParams()
  return <SettingsPage section={section} />
}
const settingsSectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/$section',
  beforeLoad: ({ params }) => {
    /* The catalog is Billing's now; its old address still opens it. */
    if (params.section === 'catalogs') {
      throw redirect({ to: '/billing/$tab', params: { tab: 'items' } })
    }
  },
  component: SettingsSectionView,
})

const SeatingLayoutPage: LazyPage = lazy(() =>
  import('../../routes/seating/LayoutBuilder').then((m) => ({
    default: m.LayoutBuilderPage,
  })),
)
const seatingLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/rooms/layout',
  beforeLoad: guardAt('/settings/rooms/layout'),
  validateSearch: (raw: Record<string, unknown>) => ({
    ...(typeof raw.room === 'string' && raw.room ? { room: raw.room } : {}),
  }),
  component: SeatingLayoutPage,
})

export const settingsRoutes = [
  settingsRoute,
  settingsSectionRoute,
  seatingLayoutRoute,
]
